import Logo121 from "../../../assets/img/logo121.png";
import "./style.scss";

export default function RightPanel({ title, subtitle, description }) {
  const stats = [
    {
      number: "11",
      label: "Etapas mapeadas\nda jornada de saúde",
    },
    {
      number: "2,4k+",
      label: "Respondentes anuais\npor cooperativa",
    },
  ];

  return (
    <div className="right-panel">
      <div className="right-panel__circle right-panel__circle--primary" />
      <div className="right-panel__circle right-panel__circle--secondary" />
      <div className="right-panel__circle right-panel__circle--tertiary">
        <img
          className="right-panel__logo"
          src={Logo121}
          alt="Logo da 121Labs"
        />
      </div>
      <div className="right-panel__brand">121 Insights CX</div>
      <div className="right-panel__content">
        <h2 className="right-panel__title">{title}</h2>
        <p className="right-panel__subtitle">{subtitle}</p>
        <p className="right-panel__description">{description}</p>
      </div>
      <div className="right-panel__stats">
        <div className="right-panel__stat right-panel__stat--featured">
          Benchmarking{"\n"}Nacional Unimed
        </div>
        {stats.map((stat) => (
          <div key={stat.number} className="right-panel__stat">
            <div className="right-panel__stat-number">{stat.number}</div>
            <div className="right-panel__stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
